<template>
  <el-container style="background-color:#F3F5F9">
    <el-col  class="left-block"  :lg="5">
      <p class="title">Alfa-Manosidosis</p>
      <el-divider style="width:80%;margin:auto"></el-divider>
      <el-row >
        <el-button class="option">
        <img src="@/assets/doc_white.png" alt=""> <span>Archivos</span> 
      </el-button>
      </el-row>
      <el-row  >
        <el-button class="option"  @click="logout()">
        <img src="@/assets/user.png" alt=""> <span>Cerrar sesión</span>
      </el-button>
      </el-row>
      <el-divider class="divender"></el-divider>
      <p class="ender">Alfa-Manosidosis 2021</p>
      
    </el-col>
    <el-col :lg="17" :offset="1" style="height:100%">
      
      <tabla v-if="showTable" @toggleAdd="toggleAdd" @toggleEdit="toggleEdit" v-model="showTable"  :elementos="elementos"/>
      <ElementoForm v-if="addActive" btnText="Agregar" @regreso="back" @submitted="handleAdd($event)" v-model:elemento="localData"/>
      <ElementoForm :key="upKey" v-if="editActive" @regreso="back" btnText="Actualizar"  @submitted="handleUpdate($event)" v-model:elemento="localData"/>
     </el-col>
  
  </el-container>

</template>

<script>
import tabla from "@/components/admin/tabla";
import ElementoForm from "@/components/admin/ElementoForm";

import {mapActions, mapState} from "vuex";
export default {
name: "admin-cms",
  components:{
  tabla, ElementoForm
  },

  data(){
  return{
    tableData: [{
      id:'werwerwerwer',
      titulo: 'titulo1',
      descripcion: 'descripcion1',
      link:'google.com'
    }],
    addActive: false,
      editActive: false,
      showTable:true,
      localData: {
        titulo: '',
        descripcion: '',
        link: '',
        file: '',
        id:''
      },
      upKey: 1
  }
  },
  methods:{
  ...mapActions({
    getElementos: 'getElementos',
    addElemento: 'addElemento',
    updateElemento: "updateElemento",
    logout: 'auth/logout'
  }),
  async handleAdd(data) {
      console.log(data+'oli')
      let elemento = data
      console.log('desde vista', elemento)
      const res = await this.addElemento(elemento)
      if (res.message) {
        this.$swal('!Oops', res.message, 'error')
      } else {
        this.$swal('Listo!', 'Elemento Agregado', 'success')
        this.localData = {
          titulo: '',
          descripcion: '',
          link: '',
          file: '',
          tipo: '',
        }
      }
    },
    
    toggleAdd() {
      this.showTable = false
      this.addActive = true
      this.editActive = false
      this.localData = {
        titulo: '',
        descripcion: '',
        link: '',
        file: '',
        id:''
      }
    },
    toggleEdit(elemento) {
      this.showTable = false
      this.localData = elemento
      this.addActive = false
      this.editActive = true
      this.upKey++
    },
      async handleUpdate(data) {
      // console.log('actualizar desde view', data )
      const res = await this.updateElemento(data);
      if (res.message) {
        this.$swal("!Oops", res.message, "error");
      } else {
        this.$swal("Listo!", "Elemento Agregado", "success");
        this.localData = {
          titulo: "",
          descripcion: "",
          link: "",
          file: "",
          tipo: "",
        };
        this.editActive = false;
      }
    },
    back(){
      this.showTable = true
      this.addActive = false
      this.editActive = false
    }
  },
  computed:{
  ...mapState({
    elementos: state => state.elementos
  })
  },
  async mounted() {
    console.log('dentro de mounted')
    await this.getElementos()
  }

}
</script>

<style lang="scss" scoped>
.left-block{
  margin-left: 1vw;
  margin-bottom: 2vh;
  margin-top: 2vh;
  height: 96vh;
  background-color: #E27367;
;
  border-radius: 30px;
}
.title{
  margin-top: 5vh;
  font-family: 'Yusei-magic';
  font-size: 24px;
  color: #fff;
  line-height: 34px;
}
.divender{
  margin: auto;
  width: 80%;
  margin-top: 47vh;
  }
.ender{
  color: #fff;
  font-family: 'Avenir';
  font-size: 14px;
  font-weight: 100;
  margin-top: 2vh;
}
.option{
  
  font-weight: 100;
  font-size: 18px;
  padding-top: 50px;
  background-color: transparent;
  color: #fff;
  margin:auto;
  margin-left: 45px;
  border: none;
}
.tab-enter-from,
.tab-leave-to {
  opacity: 1;
  transform: scale(0.6);
}

.tab-leave-from,
.tab-enter-to {
  opacity: 0;
  transform: scale(0.6);
}
.tab-enter-active, 
.tab-leave-active{
  transition: all 0.8s ease;
}
@media (max-width:1350px) {
  .divender{
    margin-top: 40vh;
  }
}
</style>